// extracted by mini-css-extract-plugin
export var danger = "_42-6";
export var lightPink = "_42-a";
export var medium = "_42-j";
export var nearSquare = "_42-m";
export var neutralBlue = "_42-8";
export var neutralYellow = "_42-7";
export var noCapitalize = "_42-1";
export var normal = "_42-2";
export var pill = "_42-0";
export var primary = "_42-3";
export var primaryLight = "_42-4";
export var shadow = "_42-n";
export var small = "_42-k";
export var solidBlack = "_42-i";
export var solidGreen = "_42-d";
export var solidLightBlue = "_42-f";
export var solidNavy = "_42-e";
export var solidOrange = "_42-h";
export var solidPink = "_42-g";
export var solidRed = "_42-b";
export var solidWhite = "_42-9";
export var solidYellow = "_42-c";
export var success = "_42-5";
export var xsmall = "_42-l";